module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users.component.html
// module id = 1082
// module chunks = 31